// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__Fredoka_dcba26', '__Fredoka_Fallback_dcba26'","fontStyle":"normal"},"className":"__className_dcba26"};